import React from "react";

const ProcessForm = props => {
    return (
        <div>
            <h1>Hi!</h1>
        </div>
    )
}

export default ProcessForm;